import { CheckboxField, List } from '@iheartjane/reefer';
import type { ReactNode } from 'react';

import { useSearchParamFilter } from '@jane/bloom/hooks/filters';
import type {
  ProductSearchFilterTypeKeys,
  SearchFilterFacet,
} from '@jane/bloom/viewModels/productSearchFilters';

export interface FilterCheckBoxProps {
  filter: SearchFilterFacet;
  filterKey: ProductSearchFilterTypeKeys;
  label?: ReactNode;
}

export const FilterCheckBox = ({
  filter,
  filterKey,
  label,
}: FilterCheckBoxProps) => {
  const { getFilterStatus, setFilter } = useSearchParamFilter(filterKey);
  const isChecked = getFilterStatus(filter.value) === 'selected';
  const displayLabel = label ?? `${filter.label} (${filter.count})`;

  const handleChange = (checked: boolean) => {
    if (checked === isChecked) return;
    setFilter(filter.value, checked);
  };

  return (
    <List.Item>
      <CheckboxField
        checked={isChecked}
        disabled={filter.count === 0}
        label={displayLabel}
        name={filter.value}
        onChange={handleChange}
      />
    </List.Item>
  );
};
